import nextOrPrevAll from "./_internal/_nextOrPrevAll.js";

export default nextOrPrevAll("nextSibling", "push");
